var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _rect4, _rect5, _rect6, _rect7, _circle, _path70, _circle2, _path71, _circle3, _path72;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapSectionBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 1111,
    viewBox: "0 0 392 1111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392 0L392 185C392 284.433 317.957 366.573 222 379.291L222 395L351 395L351 776.728C351 811.583 341.505 845.78 323.535 875.646C318.187 884.534 313.569 893.841 309.726 903.476L297.526 934.059C285.287 964.739 279 997.469 279 1030.5L278.963 1030.52C277.633 1075.19 240.998 1111 196 1111C151.002 1111 114.367 1075.19 113.037 1030.52L113 1030.5C113 997.478 106.621 964.766 94.2147 934.163L80.9835 901.526C77.3331 892.522 73.0057 883.807 68.0384 875.456C50.3411 845.704 41 811.728 41 777.11L41 395L170 395L170 379.291C74.0426 366.573 -1.2433e-05 284.433 -8.08661e-06 185L0 -1.71349e-05L392 0Z",
    fill: "#2D2F3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327 433L327 508L314 508L314 433L255 433L255 470L242 470L242 433L242 420L255 420L314 420L327 420L327 433Z",
    fill: "#343744"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327 526L327 601L327 614L314 614L287 614L287 601L314 601L314 526L327 526Z",
    fill: "#343744"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327 632L327 707L327 720L314 720L287 720L287 707L314 707L314 632L327 632Z",
    fill: "#343744"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65 720L65 645L65 632L78 632L105 632L105 645L78 645L78 720L65 720Z",
    fill: "#343744"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65 614L65 539L65 526L78 526L105 526L105 539L78 539L78 614L65 614Z",
    fill: "#343744"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65 433L65 508L78 508L78 433L137 433L137 470L150 470L150 433L150 420L137 420L78 420L65 420L65 433Z",
    fill: "#343744"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 544,
    width: 70,
    height: 243,
    rx: 35,
    fill: "#343744"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 392,
    width: 130,
    height: 392,
    transform: "rotate(90 392 0)",
    fill: "#343744"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 72,
    width: 8,
    height: 392,
    transform: "rotate(90 392 72)",
    fill: "#2D2F3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93 848L300 848",
    stroke: "#343744",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96 856L296 856",
    stroke: "#343744",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96 864L292 864",
    stroke: "#343744",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99 872L289 872",
    stroke: "#343744",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M102 880L286 880",
    stroke: "#343744",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M104 888L284 888",
    stroke: "#343744",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M105 896L283 896",
    stroke: "#343744",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M106 904L282 904",
    stroke: "#343744",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M107 912L281 912",
    stroke: "#343744",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M108 920L280 920",
    stroke: "#343744",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M109 928L279 928",
    stroke: "#343744",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M110 936L278 936",
    stroke: "#343744",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M111 944L277 944",
    stroke: "#343744",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M111 952L277 952",
    stroke: "#343744",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M111 960L277 960",
    stroke: "#343744",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M91 840L302 840",
    stroke: "#343744",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M87 832L306 832",
    stroke: "#343744",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M82 824L311 824",
    stroke: "#343744",
    strokeWidth: 2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M77 816L316 816",
    stroke: "#343744",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M72 808L321 808",
    stroke: "#343744",
    strokeWidth: 2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M119 138L119 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M113 138L113 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M107 138L107 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M101 138L101 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M95 138L95 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M89 138L89 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M83 138L83 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M77 138L77 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M71 138L71 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M65 138L65 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M59 138L59 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M53 138L53 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M47 138L47 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M41 138L41 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M35 138L35 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M29 138L29 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M23 138L23 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M17 138L17 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M11 138L11 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M5 138L5 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M386 138L386 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M380 138L380 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M374 138L374 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M368 138L368 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M362 138L362 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M356 138L356 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M350 138L350 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M344 138L344 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M338 138L338 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M332 138L332 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M326 138L326 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M320 138L320 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M314 138L314 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M308 138L308 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M302 138L302 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M296 138L296 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M290 138L290 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M284 138L284 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M278 138L278 176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M351 779L326.393 821.045C300.924 864.563 287.5 914.077 287.5 964.5V964.5L322.649 896.138C341.281 859.903 351 819.745 351 779V779Z",
    fill: "#343744"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 779L66.1068 821.045C91.5759 864.563 105 914.077 105 964.5V964.5L69.8505 896.138C51.2191 859.903 41.5 819.745 41.5 779V779Z",
    fill: "#343744"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00250244 184C0.00082396 184.333 -2.91324e-08 184.666 -4.37114e-08 185C-4.40516e-06 284.778 74.5575 367.143 171 379.421L171 355.196C87.8555 343.089 24 271.502 24 185C24 184.666 24.0009 184.333 24.0028 184L0.00250244 184ZM47.0033 184C47.0011 184.333 47 184.666 47 185C47 258.771 100.612 320.021 171 331.912L171 307.5C113.944 295.918 71 245.474 71 185C71 184.666 71.0013 184.333 71.0039 184L47.0033 184ZM320.996 184L344.997 184C344.999 184.333 345 184.666 345 185C345 258.071 292.401 318.857 223 331.56L223 307.076C279.057 294.734 321 244.765 321 185C321 184.666 320.999 184.333 320.996 184ZM96.0049 184C96.0016 184.333 96 184.666 96 185C96 231.596 127.869 270.748 171 281.85L171 256.792C141.308 246.454 120 218.215 120 185C120 184.666 120.002 184.333 120.006 184L96.0049 184ZM271.994 184L295.995 184C295.998 184.333 296 184.666 296 185C296 230.873 265.112 269.531 223 281.312L223 256.064C251.644 245.175 272 217.465 272 185C272 184.666 271.998 184.333 271.994 184ZM367.997 184L391.998 184C391.999 184.333 392 184.666 392 185C392 284.087 318.471 366.001 223 379.156L223 354.893C305.166 341.938 368 270.807 368 185C368 184.666 367.999 184.333 367.997 184Z",
    fill: "#343744"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 1,
    width: 178,
    height: 201,
    rx: 12,
    fill: "#6BDD35",
    fillOpacity: 0.1,
    stroke: "#6BDD35",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 218,
    width: 70,
    height: 201,
    rx: 12,
    fill: "#35DDDD",
    fillOpacity: 0.1,
    stroke: "#35DDDD",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 535,
    width: 67,
    height: 106,
    rx: 12,
    fill: "#C635DD",
    fillOpacity: 0.1,
    stroke: "#C635DD",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 912,
    width: 152,
    height: 198,
    rx: 12,
    fill: "#DDCD35",
    fillOpacity: 0.1,
    stroke: "#DDCD35",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 85,
    r: 13,
    fill: "#74DE4B"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M199.504 80.2727V89H197.659V82.0241H197.608L195.609 83.277V81.6406L197.77 80.2727H199.504Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 273,
    cy: 147,
    r: 13,
    fill: "#74DE4B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M269.707 151V149.67L272.814 146.794C273.078 146.538 273.3 146.308 273.479 146.104C273.661 145.899 273.798 145.699 273.892 145.503C273.986 145.304 274.033 145.089 274.033 144.859C274.033 144.604 273.974 144.384 273.858 144.199C273.741 144.011 273.582 143.868 273.381 143.768C273.179 143.666 272.95 143.615 272.695 143.615C272.428 143.615 272.195 143.669 271.996 143.777C271.797 143.885 271.643 144.04 271.536 144.241C271.428 144.443 271.374 144.683 271.374 144.962H269.622C269.622 144.391 269.751 143.895 270.01 143.474C270.268 143.054 270.631 142.729 271.097 142.499C271.563 142.268 272.099 142.153 272.707 142.153C273.332 142.153 273.876 142.264 274.339 142.486C274.805 142.705 275.168 143.009 275.426 143.398C275.685 143.787 275.814 144.233 275.814 144.736C275.814 145.065 275.749 145.391 275.618 145.712C275.49 146.033 275.261 146.389 274.932 146.781C274.602 147.17 274.138 147.638 273.538 148.183L272.264 149.432V149.491H275.929V151H269.707Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 173,
    r: 13,
    fill: "#74DE4B"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M218.933 177.119C218.297 177.119 217.73 177.01 217.233 176.791C216.739 176.57 216.348 176.266 216.061 175.879C215.777 175.49 215.631 175.041 215.622 174.533H217.48C217.491 174.746 217.561 174.933 217.689 175.095C217.82 175.254 217.993 175.378 218.209 175.466C218.425 175.554 218.668 175.598 218.938 175.598C219.219 175.598 219.467 175.548 219.683 175.449C219.899 175.349 220.068 175.212 220.19 175.036C220.313 174.859 220.374 174.656 220.374 174.426C220.374 174.193 220.308 173.987 220.178 173.808C220.05 173.626 219.865 173.484 219.624 173.382C219.385 173.28 219.101 173.229 218.771 173.229H217.957V171.874H218.771C219.05 171.874 219.295 171.825 219.509 171.729C219.724 171.632 219.892 171.499 220.011 171.328C220.131 171.155 220.19 170.953 220.19 170.723C220.19 170.504 220.138 170.312 220.033 170.148C219.93 169.98 219.786 169.849 219.598 169.756C219.413 169.662 219.197 169.615 218.95 169.615C218.7 169.615 218.472 169.661 218.264 169.751C218.057 169.839 217.891 169.966 217.766 170.131C217.641 170.295 217.574 170.489 217.565 170.71H215.797C215.805 170.207 215.949 169.764 216.227 169.381C216.506 168.997 216.881 168.697 217.352 168.482C217.827 168.263 218.362 168.153 218.959 168.153C219.561 168.153 220.088 168.263 220.54 168.482C220.991 168.7 221.342 168.996 221.592 169.368C221.845 169.737 221.97 170.152 221.967 170.612C221.97 171.101 221.818 171.509 221.511 171.835C221.207 172.162 220.811 172.369 220.322 172.457V172.526C220.964 172.608 221.453 172.831 221.788 173.195C222.126 173.555 222.294 174.007 222.291 174.55C222.294 175.047 222.151 175.489 221.861 175.875C221.574 176.261 221.178 176.565 220.672 176.787C220.166 177.009 219.587 177.119 218.933 177.119Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapSectionBox);
export default __webpack_public_path__ + "static/media/Map_section_box.6d007de86be5f54ccea2bf40b0ab0aaa.svg";
export { ForwardRef as ReactComponent };